import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaBars } from "react-icons/fa6";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";

export interface IProps {
  navOnScrollStyleValue: boolean;
}
function MenuOfNavbarComponent({ navOnScrollStyleValue }: IProps) {
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openMenuCurrency, setOpenMenuCurrency] = useState<boolean>(true);
  const [openMenuLanguage, setOpenMenuLanguage] = useState<boolean>(false);
  const [languageCheck, setLanguageCheck] = useState<string>("AR");
  const [currencyCheck, setCurrencyCheck] = useState<string>("SR");
  const popupRef = useRef<HTMLDivElement>(null);

  const { i18n, t } = useTranslation();
  const changeLanguage = (lng: string | undefined) => {
    i18n.changeLanguage(lng);
  };

  const closeOpenedMenu = () => {
    if (window.scrollY <= 50) {
      setOpenMenu(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", closeOpenedMenu);
    const handleClickOutSidePopup = ({ target }: MouseEvent) => {
      if (!popupRef?.current?.contains(target as Node)) {
        setOpenMenu(false);
      }
    };
    document.body.addEventListener("click", handleClickOutSidePopup, true);
    return () => {
      window.removeEventListener("scroll", closeOpenedMenu);
      document.body.removeEventListener("click", handleClickOutSidePopup);
    };
  }, []);

  return (
    <>
      <div
        className="flex cursor-pointer tablet:hidden laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden"
        onClick={() => {
          setOpenMenu(true);
        }}
      >
        <FaBars size={24} className="text-zinc-700" />
      </div>
      {openMenu === true ? (
        <div
          ref={popupRef}
          className={`${
            navOnScrollStyleValue
              ? `${
                  i18n.language === "ar"
                    ? "-left-4 mobile:-left-1.5 rounded-r-xl"
                    : "-right-4 mobile:-right-1.5 rounded-l-xl"
                } -top-6 mobile:-top-1.5`
              : `${
                  i18n.language === "ar"
                    ? "left-0 rounded-r-xl"
                    : "right-0 rounded-l-xl"
                } mobile:-top-4 top-0`
          } absolute z-50 w-[135px] py-2 h-fit bg-zinc-50 animate-fade animate-once animate-duration-300 animate-delay-100 animate-ease-out animate-normal drop-shadow-[0_0px_10px_rgba(0,0,0,0.05)] tablet:hidden laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden`}
        >
          <div className="flex flex-col gap-3">
            <div className="flex flex-col">
              <div
                className="flex flex-row-reverse justify-between items-center text-sm font-arLight h-7 px-2 w-full text-neutral800 border-b-[0.5px] border-[#E5E5E5] cursor-pointer"
                onClick={() => {
                  setOpenMenuCurrency(!openMenuCurrency);
                  setOpenMenuLanguage(false);
                }}
              >
                {openMenuCurrency ? (
                  <HiOutlineChevronUp
                    size={20.59}
                    className="text-neutral-600"
                  />
                ) : (
                  <HiOutlineChevronDown
                    size={20.59}
                    className="text-neutral-600"
                  />
                )}
                {t("app.shared.currency")}
              </div>
              {openMenuCurrency ? (
                <div className="flex flex-col gap-3 -mx-3 px-3 my-3 font-arLight text-neutral800 text-sm animate-flip-down animate-once animate-duration-300 animate-ease-out animate-normal">
                  <div
                    onClick={() => {
                      localStorage.setItem("currency", "SR");
                      setCurrencyCheck("SR");
                    }}
                    className={`flex ${
                      currencyCheck === "SR" ? "bg-mint-500 text-zinc50" : ""
                    } gap-1 items-center h-8 px-1 cursor-pointer`}
                  >
                    <img
                      alt=""
                      src="/assets/images/sa-icon.png"
                      className="h-6 w-6"
                    ></img>
                    {t("menuOfNavbar.component.saudiRiyal")}
                  </div>
                  <div
                    onClick={() => {
                      localStorage.setItem("currency", "EUR");
                      setCurrencyCheck("EUR");
                    }}
                    className={`flex ${
                      currencyCheck === "EUR" ? "bg-mint-500 text-zinc50" : ""
                    } gap-1 items-center h-8 px-1 cursor-pointer`}
                  >
                    <img
                      alt=""
                      src="/assets/images/uk-icon.png"
                      className="h-6 w-6"
                    ></img>
                    {t("menuOfNavbar.component.euro")}
                  </div>
                  <div
                    onClick={() => {
                      localStorage.setItem("currency", "USD");
                      setCurrencyCheck("USD");
                    }}
                    className={`flex ${
                      currencyCheck === "USD" ? "bg-mint-500 text-zinc50" : ""
                    } gap-1 items-center h-8 px-1 cursor-pointer`}
                  >
                    <img
                      alt=""
                      src="/assets/images/us-icon.png"
                      className="h-6 w-6"
                    ></img>
                    {t("menuOfNavbar.component.americanDollar")}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            {/* Change Language Dropdown */}
            <div className="flex flex-col">
              <div
                className={`${
                  openMenuLanguage ? "border-b-[0.5px] border-[#E5E5E5]" : ""
                } flex flex-row-reverse justify-between items-center text-sm font-arLight h-7 px-2 w-full text-neutral800 cursor-pointer`}
                onClick={() => {
                  setOpenMenuLanguage(!openMenuLanguage);
                  setOpenMenuCurrency(false);
                }}
              >
                {openMenuLanguage ? (
                  <HiOutlineChevronUp
                    size={20.59}
                    className="text-neutral-600"
                  />
                ) : (
                  <HiOutlineChevronDown
                    size={20.59}
                    className="text-neutral-600"
                  />
                )}
                {t("app.shared.language")}
              </div>
              {openMenuLanguage ? (
                <div className="flex flex-col gap-3 -mx-3 px-3 my-3 font-arLight text-neutral800 text-sm animate-flip-down animate-once animate-duration-300 animate-ease-out animate-normal">
                  <div
                    onClick={() => {
                      setLanguageCheck("AR");
                      changeLanguage("ar");
                    }}
                    className={`flex ${
                      languageCheck === "AR" ? "bg-mint-500 text-zinc50" : ""
                    } gap-1 items-center h-8 px-1 cursor-pointer`}
                  >
                    {t("app.shared.arabic")}
                  </div>
                  <div
                    onClick={() => {
                      setLanguageCheck("ENG");
                      changeLanguage("en");
                    }}
                    className={`flex ${
                      languageCheck === "ENG" ? "bg-mint-500 text-zinc50" : ""
                    } gap-1 items-center h-8 px-1 cursor-pointer`}
                  >
                    {t("app.shared.english")}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default MenuOfNavbarComponent;
